import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PRESCRIPTION_FEATURE_KEY,
  State,
  PrescriptionPartialState,
  prescriptionAdapter
} from './prescription.reducer';

// Lookup the 'Prescription' feature state managed by NgRx
export const getPrescriptionState = createFeatureSelector<
  PrescriptionPartialState,
  State
>(PRESCRIPTION_FEATURE_KEY);

const { selectAll, selectEntities } = prescriptionAdapter.getSelectors();

export const getPrescriptionsLoading = createSelector(
  getPrescriptionState,
  (state: State) => state.loading
);

export const getPrescriptionsError = createSelector(
  getPrescriptionState,
  (state: State) => state.error
);

export const getAllPrescription = createSelector(
  getPrescriptionState,
  (state: State) => selectAll(state)
);

export const getPrescriptionEntities = createSelector(
  getPrescriptionState,
  (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getPrescriptionState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getPrescriptionEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getPrescriptionsCreating = createSelector(
  getPrescriptionState,
  (state: State) => state.creating
);

export const getPrescriptionsUpdating = createSelector(
  getPrescriptionState,
  (state: State) => state.updating
);

export const getPrescriptionsSending = createSelector(
  getPrescriptionState,
  (state: State) => state.sending
);

export const getFulfillmentOrderId = createSelector(
  getPrescriptionState,
  (state: State) => state.fulfillmentOrderId
);
